import { create } from "zustand"
import type { TRegistration, TRegistrationSteps } from "types/auth.type"

export const useRegistrationStore = create<TRegistration>((set) => ({
	data: {
		email: "",
		firstName: "",
		lastName: "",
		password: "",
		confirmPassword: "",
		token: "",
	},
	setRegistration: (newData) =>
		set((state) => ({
			data: {
				...state.data,
				...newData,
			},
		})),
}))

export const useRegistrationStepsStore = create<TRegistrationSteps>((set) => ({
	step: 1,
	setStep: (step) => set({ step: step }),
}))
